import DirectusCombobox from "../combobox";
import FilterWrapper from "components/filter/wrapper";
import React from "react";
import client from "directus/src/client";

export default function ProjectCombobox({
  filter,
  hideLabel,
  className,
  ...props
}) {
  if (hideLabel) {
    return (
      <div className={className}>
        <DirectusCombobox
          client={client}
          collection="projects"
          fields={["id", "name"]}
          searchKeys={["name"]}
          filter={filter}
          sort={["name"]}
          placeholder="Select Project"
          {...props}
        />
      </div>
    );
  }
  return (
    <FilterWrapper label="Project" className={className}>
      <DirectusCombobox
        client={client}
        collection="projects"
        fields={["id", "name"]}
        searchKeys={["name"]}
        filter={filter}
        sort={["name"]}
        {...props}
      />
    </FilterWrapper>
  );
}
